import styled from '@emotion/styled';
import { Command } from 'lucide-react';
import { Items } from 'modules/template-editor/ui/hooks/modals/tip/style';
import { useCallback, useState } from 'react';
import Modal from 'ud-ui/components/modal';
import Item from './item';

function useTipModal() {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => {
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    modal: (
      <Modal show={isOpen} onClose={close}>
        <Modal.Header title="Подсказки" />
        <Modal.Body>
          <Items>
            <Item
              text={'Перетаскивание сетки'}
              windows={{ icon: <TextIcon>alt</TextIcon>, text: '+ клик' }}
              mac={{
                icon: <Command size={16} />,
                text: '+ клик',
              }}
            />
          </Items>
        </Modal.Body>
      </Modal>
    ),
    open,
    close,
  };
}

export default useTipModal;

const TextIcon = styled.span`
  font-family:
    SF Pro Text,
    serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  vertical-align: bottom;
  color: ${({ theme }) => theme.colors.NarcissusYellow};
`;
